(() => {
  const selectors = {
    bar: '[data-mobile-bottom-bar]',
    cartLink: '[data-cart-link]',
    mobileSearchDrawer: '[data-mobile-bottom-search-drawer] search-drawer',
    searchButtons: '[id^="Search-drawer-button-"]',
    filtersButtons: '[id^="Filters-drawer-button-"]',
    wishlistButtons:
      '[data-wishlist-trigger], .js-wishlist-trigger, a[href*="/pages/wishlist"], a[href*="/wishlist"]'
  };

  const getVisibleElement = selector => {
    const elements = Array.from(document.querySelectorAll(selector));
    if (!elements.length) return null;

    const visibleElement = elements.find(element => {
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && element.offsetParent !== null;
    });

    return visibleElement || elements[0];
  };

  const clickElement = element => {
    if (element) {
      element.click();
    }
  };

  const openSearch = () => {
    const mobileSearchDrawer = document.querySelector(selectors.mobileSearchDrawer);
    if (mobileSearchDrawer && typeof mobileSearchDrawer.toggleDrawer === 'function') {
      mobileSearchDrawer.toggleDrawer();
      return;
    }

    clickElement(getVisibleElement(selectors.searchButtons));
  };

  const openCart = fallbackTrigger => {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartLink = getVisibleElement(selectors.cartLink);

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open(cartLink || fallbackTrigger);
      return;
    }

    if (cartLink) {
      cartLink.click();
      return;
    }

    window.location.href = window.routes?.cart_url || '/cart';
  };

  const openWishlist = trigger => {
    const wishlistTrigger = getVisibleElement(selectors.wishlistButtons);
    if (wishlistTrigger) {
      clickElement(wishlistTrigger);
      return;
    }

    const fallbackUrl = trigger?.dataset?.wishlistUrl;
    if (fallbackUrl) {
      window.location.href = fallbackUrl;
    }
  };

  const openAccount = trigger => {
    const accountUrl = trigger?.dataset?.accountUrl;
    if (accountUrl) {
      window.location.href = accountUrl;
    }
  };

  const initMobileBottomBar = () => {
    const bar = document.querySelector(selectors.bar);
    if (!bar) return;

    const filtersAction = bar.querySelector('[data-mobile-bottom-action="filters"]');
    const wishlistAction = bar.querySelector('[data-mobile-bottom-action="wishlist"]');
    const syncFiltersAction = () => {
      const hasFiltersTrigger = Boolean(getVisibleElement(selectors.filtersButtons));

      if (filtersAction) {
        filtersAction.classList.toggle('is-hidden', !hasFiltersTrigger);
      }

      if (wishlistAction) {
        wishlistAction.classList.toggle('is-hidden', hasFiltersTrigger);
      }
    };

    syncFiltersAction();

    bar.addEventListener('click', event => {
      const actionButton = event.target.closest('[data-mobile-bottom-action]');
      if (!actionButton) return;

      const action = actionButton.dataset.mobileBottomAction;
      if (!action) return;

      event.preventDefault();

      if (action === 'search') {
        openSearch();
        return;
      }

      if (action === 'filters') {
        clickElement(getVisibleElement(selectors.filtersButtons));
        return;
      }

      if (action === 'cart') {
        openCart(actionButton);
        return;
      }

      if (action === 'wishlist') {
        openWishlist(actionButton);
        return;
      }

      if (action === 'account') {
        openAccount(actionButton);
      }
    });

    document.addEventListener('shopify:section:load', syncFiltersAction);
    document.addEventListener('shopify:section:reorder', syncFiltersAction);
    document.addEventListener('shopify:section:unload', syncFiltersAction);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileBottomBar);
  } else {
    initMobileBottomBar();
  }
})();
